import AOS from 'aos';
import initializeMobileMenu from './menu';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        // AOS.init({
        //     disable: 'mobile',
        //     once: true,
        //     duration: 1000
        // });
        // initializeMobileMenu();

        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
